import React from "react";

const features = [
  {
    title: "Create your profile",
    description:
      "Build a standout profile with photos, prompts, and your vibe in minutes.",
    icon: "✨",
  },
  {
    title: "Match with intention",
    description:
      "Smart recommendations surface people you actually want to meet.",
    icon: "🎯",
  },
  {
    title: "Chat with confidence",
    description:
      "Break the ice with fun prompts, voice notes, and quick reactions.",
    icon: "💬",
  },
];

function LearnSection() {
  return (
    <section id="learn" className="section-gradient py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-[0.3em] text-pink-500 font-semibold">
            Learn
          </p>
          <h2 className="heading-primary text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
            A smarter way to connect
          </h2>
          <p className="text-lg text-subtle mt-4 max-w-2xl mx-auto">
            Meet real people who match your energy. Simple steps, meaningful
            connections.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="card-hover rounded-3xl bg-white/90 border border-pink-100 shadow-sm p-6 sm:p-8"
            >
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center text-2xl mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LearnSection;
